import createDebugCore from 'debug';

export const isDebugOn = () => {
  return localStorage.getItem('debug') === '*';
};

export const createDebug = createDebugCore('skeddy');
